var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c('BreadCrumb',{attrs:{"breadCrumbData":_vm.breadcrumbs,"suppressNameAdjustments":true}}),_vm._v(" "),_c('EsySection',{attrs:{"variant":"default"}},[_c('GridContainer',[_c('EsyH1',{staticClass:"widerruf-page__title"},[_c('strong',[_vm._v("Vertrag widerrufen")])]),_vm._v(" "),_c('WiderrufForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }